import React from 'react'
import './BinanaceSmartChainBEP20TokenDevelopment.css'
import { Link } from "react-router-dom";


const BinanaceSmartChainBEP20TokenDevelopment = () => {
  return (
    <div>
      &lt;&gt;
      <main id="token_dev_main">
        <section className="token_dev_banner">
          <div className="container cus_container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-6 col-12 order-2 order-lg-1">
                <div className="bnr_img_sec">
                  <img width={'400px'} src="./images/fungiable-tokan-development-1.webp" alt="Token Development" title="Token Development" className="img-responsive" />
                  {/* <img src="" alt="Token Development" title="Token Development" className="img-fluid banner_anim_img" /> */}
                </div>
              </div>
              <div className="col-lg-6 col-12 order-1 order-lg-2">
                <div className="banner_cont_sec">
                  <h1 className="ourservice-titles-new grident-color-sub-title"><span className="bnr_bld_title">Binanace Intelligent
                  </span> <br /> Chain Tokan Creation </h1>
                  <p className="contents">The best token production company, MetaBlock, assists companies in producing tokens on any blockchain network swiftly and efficiently. Use our experience to launch your cryptocurrency token project and expand your cryptocurrency company!</p>
                  <div className="HddrBtns banner_btn_sec">
                    <a href="" target="_blank" className="btn banner_btn"><span>Make Your Token Right Now</span></a>
                    <div className="shadow_img"><svg viewBox="0 0 1320 300"><text x="50%" y="50%" dy=".35em" textAnchor="middle">Instantly</text></svg></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_crypto_sec">
          <div className="container">
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-7 col-12">
                <div className="techstack_sli">
                  <h2 className="ourservice-titles-new grident-color-sub-title">Crypto Token Development</h2>
                  <p className="contents">The process of developing digital tokens, which are usually developed on different blockchain platforms such as Ethereum, Binance Smart Chain, Polygon, TRON, Solana, etc., is known as token development. The process of developing a cryptocurrency token entails determining its objective, creating its framework, and deploying it via blockchain-based smart contracts. The cornerstone of this digital revolution, coins and tokens, with their strong cryptographic underpinnings and decentralized structure, have the potential to influence the direction of banking in the future.
                  </p>
                  <p className="contents">MetaBlock is a cryptocurrency token development company that focuses on creating one-of-a-kind tokens that are compatible with various blockchain networks. We cater to the specific requirements and objectives of our clients by offering end-to-end token development services.</p>
                  <div className="token_dev_crypto_about_btn_sec">
                    <a href="https://wa.me/9828284421" className="btn token_dev_crypto_about_btn desktop" target="_blank"><i className="fab fa-whatsapp" />&nbsp;WhatsApp</a>
                    <a href="https://wa.me/9828284421" className="btn token_dev_crypto_about_btn mobile" target="_blank"><i className="fab fa-whatsapp" />&nbsp;WhatsApp</a>
                    <a href="https://web.telegram.org/k/#@metablocktechnologies" className="btn token_dev_crypto_about_btn1" target="_blank"><i className="fab fa-telegram" />&nbsp;Telegram</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-12">
                <img src="./images/fungiable-tokan-development.webp" alt="Crypto Token Development Company" title="Crypto Token Development Company" />
              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_services">
          <div className="container back_color">
            <h2 className="ourservice-titles-new grident-color-sub-title">Our Services for Token Development</h2>
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-4 col-md-6 col-12 cus_col">
                <div className="service_box">
                  <img width={'80px'} src="./images/ethereum.webp" alt="Ethereum Token Development" title="Ethereum Token Development" />
                  <h3 className="sub_title">Ethereum Token Creation</h3>
                  <p className="sub_contents">With Ethereum tokens that follow a variety of standards, including as ERC-20, ERC-721, ERC-223, ERC-1155, ERC-1400, and more, you may improve your blockchain project.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 cus_col">
                <div className="service_box">
                  <img width={'80px'} src="./images/coin.webp" alt="Tron Token Development" title="Tron Token Development" />
                  <h3 className="sub_title">Development of Tron Tokens</h3>
                  <p className="sub_contents">You may improve your blockchain dApps by developing TRON currencies that adhere to industry standards such as TRC-10, TRC-20, and TRC-721.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="service_box">
                  <img width={'80px'} src="./images/solana.webp" alt="Solana Token Development" title="Solana Token Development" />
                  <h3 className="sub_title">Development of Solana Tokens</h3>
                  <p className="sub_contents">Our expertise lies in developing personalized tokens on Solana and other blockchain platforms using customized smart contract solutions.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 cus_col">
                <div className="service_box">
                  <img width={'80px'} src="./images/polygon.webp" alt="Polygon Token Development" title="Polygon Token Development" />
                  <h3 className="sub_title">Development of Polygon Tokens</h3>
                  <p className="sub_contents">Our talented team of engineers offers the best-in-class token development service; use it to create your own cryptocurrency token on the Polygon blockchain network.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 cus_col">
                <div className="service_box">
                  <img width={'80px'} src="./images/virtual-currency.webp" alt="Asset Token Development" title="Asset Token Development" />
                  <h3 className="sub_title">Development of Asset Tokens</h3>
                  <p className="sub_contents">Easily convert and tokenize legal securities for tangible assets with our user-friendly asset tokenization services.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="service_box">
                  <img width={'80px'} src="./images/digital-token.webp" alt="Metaverse Token Development" title="Metaverse Token Development" />
                  <h3 className="sub_title">Development of Metaverse Tokens</h3>
                  <p className="sub_contents">We create, develop, and implement virtual tokens for the metaverse on well-known blockchain networks. Explore the immersive metaverse with the help of our knowledgeable staff.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 cus_col">
                <div className="service_box">
                  <img width={'80px'} src="./images/smart-contracts.webp" alt="Smart Contract Development" title="Smart Contract Development" />
                  <h3 className="sub_title">Development of Smart Contracts</h3>
                  <p className="sub_contents">Discover comprehensive security audit and smart contract development services catered to your cryptocurrency ventures or business on a variety of blockchain platforms.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 cus_col">
                <div className="service_box">
                  <img width={'80px'} src="./images/tokens.webp" alt="Token Generator Platform Development" title="Token Generator Platform Development" />
                  <h3 className="sub_title">Development of Token Generator Platform</h3>
                  <p className="sub_contents">Build your own unique token generating platform to assist other cryptocurrency entrepreneurs in introducing their tokens to the market with assurance, encouraging creativity and expansion within the blockchain community.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="service_box">
                  <img width={'80px'} src="./images/coin.webp" alt="Altcoin Token Development" title="Altcoin Token Development" />
                  <h3 className="sub_title">Development of Altcoin Tokens</h3>
                  <p className="sub_contents">Utilize our cutting-edge altcoin development services to realize your vision and create outstanding altcoins that resemble existing cryptocurrencies like Ripple, Ethereum, or others.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_odd_serv">
          <div className="container">
            <h2 className="ourservice-titles-new grident-color-sub-title">Our Supplementary Services</h2>
            <div className="odd_serv_cardsec">
              <div className="card">
                <div className="imgBx" data-taxt="Design">
                  <img src="./images/retail.webp" alt="Liquidity-Provision-and-Market-Making" title="Liquidity Provision and Market Making" />
                </div>
                <div className="content_sec">
                  <div>
                    <h3 className="sub_title">Supplying Liquidity and Creating Markets</h3>
                    <p className="sub_contents">supplying specialized token generating platforms and all-inclusive marketing solutions for ICOs, STOs, DeFi, and NFTs to enable cryptocurrency entrepreneurs Utilize our knowledgeable staff to increase token market presence and liquidity.</p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="imgBx" data-taxt="Code">
                  <img src="./images/wallet.webp" alt="Token-Wallet-Development" title="Token Wallet Development" />
                </div>
                <div className="content_sec">
                  <div>
                    <h3 className="sub_title">Development of Token Wallets</h3>
                    <p className="sub_contents">We provide hardware and cold wallet safe token wallet development, guaranteeing two-factor authentication, fresh public keys for every transaction, QR code scanning, and session timeouts for maximum security.</p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="imgBx" data-taxt="startup">
                  <img src="./images/contracts.webp" alt="White-Paper-Creation" title="White Paper Creation" />
                </div>
                <div className="content_sec">
                  <div>
                    <h3 className="sub_title">White Paper Production</h3>
                    <p className="sub_contents">With our help, you can increase the expertise of your brand and demonstrate to potential investors your legitimacy and leadership by using eye-catching images, engaging information, and clear communication in your white paper.</p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="imgBx" data-taxt="Money">
                  <img src="./images/token.webp" alt="ICO-Development" title="ICO Development" />
                </div>
                <div className="content_sec">
                  <div>
                    <h3 className="sub_title">Development of ICOs</h3>
                    <p className="sub_contents">To fund cryptocurrency projects, create your own tokens. Through exchange agreements and specialized websites, our professionals draw in investors. When necessary, our team builds exchange partnerships, gateways, and token-offering schemes.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section className="token_dev_models">
          <div className="container">
            <h2 className="ourservice-titles-new grident-color-sub-title">Different Models for Token Development</h2>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="model_box">
                  <h3 className="different-modal-boxes-headings ">Tokens for Security</h3>
                  <p className="sub_contents">With the help of our security token development services, you may take advantage of dependable and credible blockchain-based fundraising alternatives, realizing the possibility of secure, efficient, and user-friendly fundraising.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="model_box">
                  <h3 className="different-modal-boxes-headings">Tokens of Equity</h3>
                  <p className="sub_contents">With our design-driven process, you can experience smart fundraising where we create and deploy equity tokens that will transform the way you raise money for your initiatives.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="model_box">
                  <h3 className="different-modal-boxes-headings">Tokens for the Metaverse</h3>
                  <p className="sub_contents">To begin an immersive journey, create virtual reality metaverse tokens on top blockchain platforms that are appropriate for your business.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="model_box">
                  <h3 className="different-modal-boxes-headings">DeFi tokens</h3>
                  <p className="sub_contents">Reach your company goals with a personalized DeFi token created and supplied by our knowledgeable staff, which is tailored to meet your needs in an easy and satisfying way.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="model_box">
                  <h3 className="different-modal-boxes-headings">Utility Tokens</h3>
                  <p className="sub_contents">You may ride the rising waves of the initial coin offering (ICO) market with our utility tokens, which are made to attract more investors and capitalize on the developing opportunities in the cryptocurrency business.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="model_box">
                  <h3 className="different-modal-boxes-headings">Non-Fungible Tokens</h3>
                  <p className="sub_contents">You can tokenize unique assets, including as artwork, collectibles, and real estate, and gain ownership of one-of-a-kind products with blockchain-backed authenticity by generating your NFT tokens with us.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_benefits">
          <div className="container">
            <h2 className="ourservice-titles-new grident-color-sub-title">Introducing Your Own Crypto Token Has Its Advantages</h2>
            <div className="row align-items-center">
              <div className="col-lg-5 col-12 order-2 order-lg-1 benefits_img_mblsec">
                <img src="./images/YourOwnCrypto-Token.webp" style={{ borderRadius: '13px' }} alt='Benefits of Introducing Your Own Crypto Token' title="Benefits of Introducing Your Own Crypto Token" />
              </div>
              <div className="col-lg-7 col-12 order-1 order-lg-2">
                <div className="benefits_list_sec">
                  <div className="benefits_list">
                    <div className="contents_sec d-flex justify-center align-center flex-column">
                      <img width={'60px'} src="./images/fundraising.webp" alt="Benefits List Icon" title="Benefits List Icon" className="img-fluid" />
                      <h3 className="sub_title">Distributed Fundraising</h3>
                      <p className="sub_contents">The creation of cryptocurrency tokens makes it possible for companies to generate capital through token sales or initial coin offerings (ICOs), offering a decentralized and effective substitute for conventional fundraising techniques.</p>
                    </div>
                  </div>
                  <div className="benefits_list">
                    <div className="contents_sec d-flex justify-center align-center flex-column">
                      <img width={'60px'} src="./images/sale.webp" alt="Benefits List Icon" title="Benefits List Icon" className="img-fluid" />
                      <h3 className="sub_title">Increased Accessibility</h3>
                      <p className="sub_contents">Businesses can improve liquidity and allow fractional ownership by designing tokens that reflect real-world goods or services. This will make it simpler for investors to purchase, sell, and swap tokens on different cryptocurrency exchanges.</p>
                    </div>
                  </div>
                  <div className="benefits_list">
                    <div className="contents_sec d-flex justify-center align-center flex-column">
                      <img width={'60px'} src="./images/global-connection.webp" alt="Benefits List Icon" title="Benefits List Icon" className="img-fluid" />
                      <h3 className="sub_title">Worldwide Reach</h3>
                      <p className="sub_contents">Businesses may reach a worldwide customer base using cryptocurrency tokens, removing obstacles and facilitating cross-border transactions without the need for middlemen, which speeds up and lowers the cost of doing business internationally.</p>
                    </div>
                  </div>
                  <div className="benefits_list">
                    <div className="contents_sec d-flex justify-center align-center flex-column">
                      <img width={'60px'} src="./images/dollar.webp" alt="Benefits List Icon" title="Benefits List Icon" className="img-fluid" />
                      <h3 className="sub_title">The Token Economy</h3>
                      <p className="sub_contents">Creating cryptocurrency tokens enables companies to create tokenomics that complement their business plan, putting in place systems like voting, staking, and burning to control the token supply and encourage network engagement.</p>
                    </div>
                  </div>
                  <div className="benefits_list">
                    <div className="contents_sec d-flex justify-center align-center flex-column">
                      <img width={'60px'} src="./images/events.webp" alt="Benefits List Icon" title="Benefits List Icon" className="img-fluid" />
                      <h3 className="sub_title">Event acceleration</h3>
                      <p className="sub_contents">Token transactions are faster than with other cryptocurrencies, which is necessary to improve the security and convenience of payments for all transactions.</p>
                    </div>
                  </div>
                  <div className="benefits_list">
                    <div className="contents_sec d-flex justify-center align-center flex-column">
                      <img width={'60px'} src="./images/monetary.webp" alt="Benefits List Icon" title="Benefits List Icon" className="img-fluid" />
                      <h3 className="sub_title">Monetary inclusion</h3>
                      <p className="sub_contents">Tokens with cryptocurrency properties can offer banking and financial services to underbanked and unbanked people, creating avenues for them to participate in the economy.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_process">
          <div className="container">
            <h2 className="ourservice-titles-new grident-color-sub-title">How to Develop Your Own Cryptocurrency Token</h2>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="process_box">
                  <div className="head_sec">
                    <span className="num_sec">01</span>
                    <h3 className="sub_title">Development of Smart Contracts</h3>
                  </div>
                  <p className="sub_contents">The development team then goes on to design the token's smart contract, either by creating a custom smart contract when necessary or by implementing the selected token standard (such as ERC-20, ERC-721, or BEP-20).</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="process_box">
                  <div className="head_sec">
                    <span className="num_sec">02</span>
                    <h3 className="sub_title">Setting Up Token Identity</h3>
                  </div>
                  <p className="sub_contents">An essential part of the token production process is token identity establishment, which involves user-specified decisions including choosing the token's name, symbol, and capabilities in order to produce a distinct and identifiable token.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="process_box">
                  <div className="head_sec">
                    <span className="num_sec">03</span>
                    <h3 className="sub_title">Writing of Whitepapers</h3>
                  </div>
                  <p className="sub_contents">Our talented content writers skillfully organize whitepapers according to your company's requirements, showcasing the goals, technologies, and vision of your project in an understandable and engaging way.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="process_box">
                  <div className="head_sec">
                    <span className="num_sec">04</span>
                    <h3 className="sub_title">Initiative Discovery</h3>
                  </div>
                  <p className="sub_contents">The business works in tandem with the client to comprehend use cases, business goals, and particular requirements.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="process_box">
                  <div className="head_sec">
                    <span className="num_sec cus_numsec">05</span>
                    <h3 className="sub_title cus_subtitle">Select a Blockchain Platform</h3>
                  </div>
                  <p className="sub_contents"> tokens are blockchain-based smart contracts & choosing  appropriate blockchain framework is essential for token development.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="process_box">
                  <div className="head_sec">
                    <span className="num_sec">06</span>
                    <h3 className="sub_title">Launch of Tokens</h3>
                  </div>
                  <p className="sub_contents">We provide the highest degree of quality and compliance for your tokens by building them with a commitment to numerous criteria.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="process_box">
                  <div className="head_sec">
                    <span className="num_sec">07</span>
                    <h3 className="sub_title">Launch of an ICO</h3>
                  </div>
                  <p className="sub_contents">Your tokens and ICO launch are well-positioned for a prosperous cryptocurrency market debut.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_techstack">
          <div className="container">
            <h2 className="ourservice-titles-new grident-color-sub-title">Our Technology Stack</h2>
            <div className="row tech ">
              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/physics.webp" className="w-100 h-40" alt="React" />
                <h5>React</h5>
              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/python.webp" alt="Python" className="w-100 h-40" />
                <h5>Python</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3" >
                <img src="./images/mysql.webp" alt="MySQL" className="w-100 h-40" />
                <h5>MySQL</h5>
              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/java-script.webp" alt="Java Srcipt" className="w-100 h-40" />
                <h5>Java Srcipt</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/SQL-Lite.webp" alt="SQL Lite" className="w-100 h-40" />
                <h5>SQL Lite</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/html.webp" alt="HTML" className="w-100 h-40" />
                <h5>HTML</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/android.webp" alt="Android" className="w-100 h-40" />
                <h5>Android</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/mongo-db-icon.webp" alt="Mongo DB" className="w-100 h-40" />
                <h5>Mongo DB</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/app-store.webp" alt="App Store" className="w-100 h-40" />
                <h5>App Store</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/atom.webp" alt="Atom" className="w-100 h-40" />
                <h5>Atom</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/laravel.webp" alt="Laravel" className="w-100 h-40" />
                <h5>Laravel</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/python.webp" alt="Python" className="w-100 h-40" />
                <h5>Python</h5>

              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_features">
          <div className="container">
            <h2 className="ourservice-titles-new grident-color-sub-title">Unique Elements in the Creation of Crypto Tokens</h2>
            <div className="row justify-content-center align-items-center" id="feature_bg_color">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="feature_box">
                  <div className="head_sec">
                    <img width={'45px'} src="./images/ownership.webp" alt="Access to Ownership" title="Access to Ownership" />
                    <h3 className="sub_title">Obtaining Ownership</h3>
                  </div>
                  <p className="sub_contents">As a token holder, you get freedom and autonomy in your blockchain project by being able to create new tokens and manage them independently.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="feature_box">
                  <div className="head_sec">
                    <img width={'45px'} src="./images/3d.webp" alt="Mintable" title="Mintable" />
                    <h3 className="sub_title">Mintable</h3>
                  </div>
                  <p className="sub_contents">A key step in the development of tokens is token minting, which enables the production of new tokens with exact attributes and functionalities.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="feature_box">
                  <div className="head_sec">
                    <img width={'45px'} src="./images/procrastination.webp" alt="Token Pause" title="Token Pause" />
                    <h3 className="sub_title">Pause for Tokens</h3>
                  </div>
                  <p className="sub_contents">With the help of this function, token circulation is managed and planned for, improving security and facilitating efficient operations inside your blockchain ecosystem.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="feature_box">
                  <div className="head_sec">
                    <img width={'45px'} src="./images/concealer.webp" alt="Capped" title="Capped" />
                    <h3 className="sub_title">Concealed</h3>
                  </div>
                  <p className="sub_contents">With our capped token generation technique, we meticulously adhere to the published token count, offering transparency and confidence.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="feature_box">
                  <div className="head_sec">
                    <img width={'45px'} src="./images/tokens.webp" alt="Burnable token" title="Burnable token" />
                    <h3 className="sub_title">Combustible token</h3>
                  </div>
                  <p className="sub_contents">This functionality increases the overall usefulness of your blockchain-based asset and gives you more control over token circulation.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="feature_box">
                  <div className="head_sec">
                    <img width={'45px'} src="./images/clipboard.webp" alt="Detailed" title="Detailed" />
                    <h3 className="sub_title">Specific</h3>
                  </div>
                  <p className="sub_contents">A name, a symbol, and a predetermined number of decimals will all be present on your token, making it an easily navigable and broadly available blockchain asset.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="token_dev_join_cardsec">
        <div className="container">
          <div className="row" id="token_dev_join_card">
            <div className="col-xl-7">
              <div className="title">Take the Step to Realize Your Complete Potential</div>
              <div className="token_dev_btn_sec">
                <button data-toggle="modal" data-target="#popup_form_modal" className="btn token_dev_btn"><span>Get Your Free Demo Right Now.</span></button>
              </div>
            </div>
            <div className="col-xl-5" />
          </div>
        </div>
      </section> */}
        <section className="token_dev_platforms">
          <div className="container">
            <h2 className="ourservice-titles-new grident-color-sub-title">Several Platforms We Are Skilled in</h2>
            <div className="row align-items-center">
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/ethereum.webp" alt="ethereum" title="ethereum" />
                  <div className="sub_title">Ethereum</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/diagnosis.webp" alt="Eos" title="Eos" />
                  <div className="sub_title">Eos</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/tezos.webp" alt="Tezos" title="Tezos" />
                  <div className="sub_title">Tezos</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/blockchain.webp" alt="Hyperledger" title="Hyperledger" />
                  <div className="sub_title">Hyperledger</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/stellar-coin.webp" alt="Stellar" title="Stellar" />
                  <div className="sub_title">Stellar</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/polygon.webp" alt="Matic" title="Matic" />
                  <div className="sub_title">Matic</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/fantom.webp" alt="Fantom" title="Fantom" />
                  <div className="sub_title">Fantom</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/ripple.webp" alt="Ripple" title="Ripple" />
                  <div className="sub_title">Ripple</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/solana.webp" alt="Solana" title="Solana" />
                  <div className="sub_title">Solana</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/polygon.webp" alt="Polygon" title="Polygon" />
                  <div className="sub_title">Polygon</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/binance.webp" alt="Binance smart chain" title="Binance smart chain" />
                  <div className="sub_title">Binance smart chain</div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="platform_list">
                  <img width={'50px'} src="./images/economic.webp" alt="Huabi ECO Chain" title="Huabi ECO Chain" />
                  <div className="sub_title">Huabi ECO Chain</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_sectors">
          <div className="container">
            <h2 className="ourservice-titles-new grident-color-sub-title">Traditional Sectors Are Being Shaped by Crypto Tokens</h2>
            <p className="contents">Enhanced Sectors Utilizing Intelligent Coins</p>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="sector_box">
                  <img width={'50px'} src="./images/finance.webp" alt="Finance" title="Finance" />
                  <h3 className="sub_title">Finance</h3>
                  <p className="sub_contents">Decentralized borrowing, trading, and lending via DeFi tokens.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="sector_box">
                  <img width={'50px'} src="./images/real-estate.webp" alt="Real Estate" title="Real Estate" />
                  <h3 className="sub_title">Property</h3>
                  <p className="sub_contents">Properties that are tokenized for smooth transactions, liquidity, and fractional ownership.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="sector_box">
                  <img width={'50px'} src="./images/game-controller.webp" alt="Gaming" title="Gaming" />
                  <h3 className="sub_title">Playing games</h3>
                  <p className="sub_contents">Generating virtual assets and in-game tokens to improve gameplay and facilitate trading.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="sector_box">
                  <img width={'50px'} src="./images/blockchain.webp" alt="Supply Chain" title="Supply Chain" />
                  <h3 className="sub_title">Chain of Supply</h3>
                  <p className="sub_contents">Introducing supply chain tokens to improve product transparency and traceability.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="sector_box">
                  <img width={'50px'} src="./images/balance.webp" alt="Energy and Sustainability" title="Energy and Sustainability" />
                  <h3 className="sub_title">Power and Ecological Balance</h3>
                  <p className="sub_contents">Using tokens for sustainable projects to incentivize eco-friendly behavior.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="sector_box">
                  <img width={'50px'} src="./images/healthcare.webp" alt="Healthcare" title="Healthcare" />
                  <h3 className="sub_title">Medical Care</h3>
                  <p className="sub_contents">Utilizing health tokens to enable safe and open exchange of health data.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_whymetablock">
          <div className="container">
            <div className="row  justify-center align-items-center">
              <div className="col-lg-5 col-12 order-2 order-lg-1">
                <img src="./images/Cryptocurrency-Token-Development-Services-1.webp" alt="Why Choose MetaBlock For Cryptocurrency Token Development Services?" title="Why Choose MetaBlock For Cryptocurrency Token Development Services?" className="Cryptocurrency-Token-Development-Services-1" />
              </div>
              <div className="col-lg-7 col-12 order-1 order-lg-2">
                <div>
                  <h2 className="ourservice-titles-new grident-color-sub-title">Why Opt for Cryptocurrency Token Development Services From MetaBlock?</h2>
                  <p className="contents">At MetaBlock, we're proud of our all-encompassing approach to token creation. We use market trends and cryptocurrency performance data to deliver top-notch token production services to business owners. Because of our experience, we can design tokens with dynamic properties like fungibility, traceability, and scalability, which guarantee effective performance in the always changing cryptocurrency market.</p>
                  <p className="contents">At a reasonable cost, our token development company provides unique functional aspects that support users' best interests. With the help of our skilled developers, we can provide quick turnaround times for our effective token development solutions, enabling companies to quickly take advantage of market prospects. We provide our Crypto Token Development Solutions worldwide, so companies may take advantage of our knowledge no matter where they are in the world.In addition,
                  </p>
                  <Link to="/contact-us">
                    <div className="token_dev_btn_sec">
                      <button data-toggle="modal" data-target="#popup_form_modal" className="btn token_dev_btn"><span>Talk To Our Expert</span></button>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>

  )
}

export default BinanaceSmartChainBEP20TokenDevelopment
